import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

export default function SelectedFilters({isInSidebar}) {
    const { filters, removeAll } = useProductFilters()

    return (filters.length > 0 && (
        <div class="ns-selected-filters">
            {filters.map(filter => (
                <button type="button" class="ns-selected-filter-btn" onClick={() => filter.remove()}>
                    <span class="ns-selected-filter-text">{filter.value}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14px" height="14px" viewBox="0 0 14 14" version="1.1">
                        <g id="B2---PLP-&amp;-Filter/Sort" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="PLP---Mobile-Filter-State" transform="translate(-962.000000, -1256.000000)" stroke="#FFFFFF" stroke-width="2"><g id="Group-21-Copy-2" transform="translate(806.000000, 1248.000000)"><g id="Group-11-Copy-5" transform="translate(93.000000, 0.000000)"><g id="Group-Copy-9" transform="translate(64.000000, 9.000000)"><line x1="0" y1="0" x2="12" y2="12" id="Path"/><line x1="0" y1="12" x2="12" y2="0" id="Path"/></g></g></g></g></g>
                    </svg>
                </button>
            ))}
            {!isInSidebar && (
                <button 
                    type="button"
                    class="ns-sidebar-header-clear-filters ns-clear-all"
                    onClick={removeAll}
                >
                    Clear All
                </button>
            )}
        </div>
    ))
}
